import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const todoSlice = createSlice({
  name: 'todos',
  initialState: {
    authen: false,
    drawer: false,
    openSidebar: false,
    title: '',
    biz_id: '',
    business_name: '',
    style: {
      primary_color: '',
      secondary_color: ''
    },
    logo: null,
    background: null,
    name: {
      title: 'นาย',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
    },
    objective: [],
    file: [],
    filename: '',
    file_id: '',
    file_alert_message: '',
    file_alert_color: '',
    file_alert_show: false,
    member_success: [],
    member_fail: [],
    roles: [],
    stepredux:'manage_member',
    historydetail:{},
    historysuccess:0,
    historyfail:'',
    current_role: '',
    change_password: null,
    consent_accepted: null,
    requested_ca: null,
    confirmed_email: null,
    services: [],
    cid: '',
    corporation_Id: '',
    portal:null
  },
  reducers: {
    setAuthen: (state, action) => {
      state.authen = action.payload.authen
    },
    setDrawer: (state, action) => {
      state.drawer = action.payload.drawer
    },   
    setOpenSidebar: (state, action) => {
      state.openSidebar = action.payload.openSidebar
    },   
    setServices: (state, action) => {
      state.services = action.payload.services
    },   
    setTitle: (state, action) => {
      state.title = action.payload.title
    },
    setBusinessName: (state, action) => {
      state.business_name = action.payload.business_name
    },
    setName: (state, action) => {
      state.name.title = action.payload.name.title
      state.name.firstname = action.payload.name.firstname
      state.name.lastname = action.payload.name.lastname
    },   
    setFileAlert: (state, action) => {
      state.file_alert_message = action.payload.file_alert_message
      state.file_alert_color = action.payload.file_alert_color
      state.file_alert_show = action.payload.file_alert_show
    },   
    Logout: (state, action) => {
      const [ cookie, setCookie, removeCookie ] = useCookies(['account'])
      removeCookie('access_token')
      removeCookie('account')
      localStorage.removeItem('account')
      state.authen = false
    },
    setFile: (state, action) => {
      if(action.payload.file !== undefined) {
        state.file = action.payload.file
      }
      if(action.payload.filename !== undefined) {
        state.filename = action.payload.filename
      }
      if(action.payload.file_id !== undefined) {
        state.file_id = action.payload.file_id
      }
    },
    setObjective: (state, action) => {
      state.objective = action.payload.objective
    },
    setObjectiveCheck: (state, action) => {
      state.objective_check = action.payload.objective_check
    },
    setBizID: (state, action) => {
      state.biz_id = action.payload.biz_id
    },
    setStyle: (state, action) => {
      state.style = action.payload.style
    },
    setMemberSuccess: (state, action) => {
      state.member_success = action.payload.member_success
    },
    setMemberFail: (state, action) => {
      state.member_fail = action.payload.member_fail
    },
    setLogo: (state, action) => {
      state.logo = action.payload.logo
    },
    setBackground: (state, action) => {
      state.background = action.payload.background
    },
    setRoles: (state, action) => {
      state.roles = action.payload.roles
    },
    setStepRedux: (state, action) => {
      state.stepredux = action.payload.stepredux
    },
    setHistoryDetail: (state, action) => {
      state.historydetail = action.payload.historydetail
    },
    setHistorySuccess: (state, action) => {
      state.historysuccess = action.payload.historysuccess
    },
    setHistorySuccessIncrease: (state, action) => {
      state.historysuccess =  state.historysuccess + 1
      state.historyfail =  state.historyfail - 1
    },
    setHistoryFail: (state, action) => {
      state.historyfail = action.payload.historyfail
    },
    setHistoryFailToSuccess: (state, action) => {
      state.historydetail.importHistories[state.historydetail.importHistories.length - 1].failDetail = state.historydetail.importHistories[state.historydetail.importHistories.length - 1].failDetail.filter((member,index)=>{
        if(member.request.index != action.payload.index){
          return true
        }
      })
      state.historydetail.importHistories[state.historydetail.importHistories.length - 1].successDetail.push(action.payload.detail)
    },
    setCurrentRole: (state, action) => {
      state.current_role = action.payload.current_role
    },
    setChangePassword:(state, action) => {
      state.change_password = action.payload.change_password
    },
    setConsentAccepted:(state, action) => {
      state.consent_accepted = action.payload.consent_accepted
    },
    setRequestCA:(state, action) => {
      state.requested_ca = action.payload.requested_ca
    },
    setConfirmEmail:(state, action) => {
      state.confirmed_email = action.payload.confirmed_email
    },
    setCID: (state, action) => {
      state.cid = action.payload.cid
    },
    setCorporationId: (state, action) => {
      state.corporation_Id = action.payload.corporation_Id
    },
    setEmail: (state, action) => {
      state.corporation_Id = action.payload.email
    },
    setPortal: (state, action) => {
      state.portal = action.payload.portal
    }
  },
})

export default todoSlice.reducer;

export const {
  setAuthen,
  setDrawer,
  setOpenSidebar,
  setTitle,
  setServices,
  setName,
  Logout,
  setFile,
  setCurrentRole,
  setBizID,
  setStyle,
  setBusinessName,
  setMemberSuccess,
  setMemberFail,
  setObjective,
  setObjectiveCheck,
  setLogo,
  setBackground,
  setRoles,
  setFileAlert,
  setStepRedux,
  setHistoryDetail,
  setHistorySuccess,
  setHistorySuccessIncrease,
  setHistoryFail,
  setHistoryFailToSuccess,
  setChangePassword,
  setRequestCA,
  setConsentAccepted,
  setConfirmEmail,
  setCID,
  setCorporationId,
  setEmail,
  setPortal
} = todoSlice.actions

export const getAuthen = (state) => state.todos.authen
export const getDrawer = (state) => state.todos.drawer
export const getTitle = (state) => state.todos.title
export const getName = (state) => state.todos.name
export const getFile = (state) => state.todos.file
export const getFilename = (state) => state.todos.filename
export const getFileID = (state) => state.todos.file_id
export const getBizID = (state) => state.todos.biz_id
export const getStyle = (state) => state.todos.style
export const getMemberSuccess = (state) => state.todos.member_success
export const getMemberFail = (state) => state.todos.member_fail
export const getObjective = (state) => state.todos.objective
export const getObjectiveCheck = (state) => state.todos.objective_check
export const getLogo = (state) => state.todos.logo
export const getBackground = (state) => state.todos.background
export const getRoles = (state) => state.todos.roles
export const getBizName = (state) => state.todos.business_name
export const getFileAlertColor = (state) => state.todos.file_alert_color
export const getFileAlertMessage = (state) => state.todos.file_alert_message
export const getFileAlertShow = (state) => state.todos.file_alert_show
export const getStepRedux = (state) => state.todos.stepredux
export const getHistoryDetail = (state) => state.todos.historydetail
export const getHistorySuccess = (state) => state.todos.historysuccess
export const getHistoryFail = (state) => state.todos.historyfail
export const getCurrentRole = (state) => state.todos.current_role
export const getChangePassword = (state) => state.todos.change_password
export const getRequestCA = (state) => state.todos.requested_ca
export const getConfirmEmail = (state) => state.todos.confirmed_email
export const getServices = (state) => state.todos.services
export const getOpenSidebar = (state) => state.todos.openSidebar
export const getConsentAccepted = (state) => state.todos.consent_accepted
export const getCID = (state) => state.todos.cid
export const getCorporationId = (state) => state.todos.corporation_Id
export const getEmail = (state) => state.todos.email
export const getPortal = (state) => state.todos.portal
